import { IconNames } from 'sprite/types';

import { SocialLinksFragment } from 'types/api/dato-operations.types';

const SOCIAL_ICON_LOOKUP: Record<keyof SocialLinksFragment, IconNames> = {
  facebook: 'LogoFacebook',
  instagram: 'LogoInstagram',
  linkedin: 'LogoLinkedin',
  twitter: 'LogoTwitterX',
  snapchat: 'LogoSnapchat',
};

type SocialLink = {
  key: string;
  href: string;
  iconName: IconNames;
};

export const mapSocialLinks = (links?: SocialLinksFragment) => {
  if (!links) return [];

  return Object.entries(links).reduce<Array<SocialLink>>(
    (memo, [key, href]) => {
      if (!!href) {
        memo.push({
          key,
          href,
          iconName: SOCIAL_ICON_LOOKUP[key as keyof SocialLinksFragment],
        });
      }
      return memo;
    },
    [],
  );
};
